import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type SelectionMap = Record<string, any>;

type SelectionContextType = {
  getSelection: <T>(key: string, initSelection: T) => [T, (selections: T) => void];
}

const SelectionContext = createContext<SelectionContextType | undefined>(undefined);

export const SelectionProvider = ({ children }: { children: ReactNode }) => {
    const location = useLocation();
    const [selectionsMap, setSelectionsMap] = useState<SelectionMap>({});

    useEffect(() => {
        const newMap: SelectionMap = {};
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith("selection-")) {
                const basePath = key.replace("selection-", "");
                if (location.pathname.startsWith(basePath)) {
                const saved = localStorage.getItem(key);
                if (saved) newMap[basePath] = JSON.parse(saved);
                }
            }
        });
        setSelectionsMap(newMap);
    }, [location.pathname]);

    const getSelection = <T,>(basePath: string, initSelection: T): [T, (selections: T) => void] => {
        const current = selectionsMap[basePath] ?? initSelection;

        const setSelection = (newSelection: T) => {
            setSelectionsMap(prev => ({
                ...prev,
                [basePath]: newSelection
            }));
            localStorage.setItem(`selection-${basePath}`, JSON.stringify(newSelection));
        };

        return [current, setSelection];
    };
    return (
        <SelectionContext.Provider value={{ getSelection }}>
            {children}
        </SelectionContext.Provider>
    );
}

export const useSelectionContext = () => {
  const context = useContext(SelectionContext);
  if (!context) throw new Error("useFilterContext must be used within a FilterProvider");
  return context;
};